import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import Portfolio from "components/blogs/GridWithFeaturedPost";
import { PortfolioData } from "../assets/portfolioData";


export default () => {
  return (
    <AnimationRevealPage>
      <Header />

      <Portfolio heading="Portfolio" posts={PortfolioData} />

      <Footer />
    </AnimationRevealPage>
  );
};
